import { render, staticRenderFns } from "./TopicFilePreview.vue?vue&type=template&id=43381def&scoped=true"
import script from "./TopicFilePreview.vue?vue&type=script&lang=js"
export * from "./TopicFilePreview.vue?vue&type=script&lang=js"
import style0 from "./TopicFilePreview.vue?vue&type=style&index=0&id=43381def&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43381def",
  null
  
)

export default component.exports